import axios from 'axios'
import { getBaseUrl } from '@/helpers/Utils';

const baseURL = process.env.REACT_APP_API_BASE_URL || getBaseUrl()
// const baseURL = getBaseUrl()

export const apiClient = axios.create({
    baseURL: `${baseURL}/api`,
    headers: {'Accept': 'application/json'}
});
